import { Label, type SemanticSIZES } from "semantic-ui-react";
import cn from "classnames";

import styles from "./Badge.module.scss";

export interface BadgeProps {
  count: number;
  size?: SemanticSIZES;
  color?: "primary";
  alignment?: "center";
}

const colorToClass: Record<string, string> = {
  primary: styles.primary,
};

const alignmentToClass: Record<string, string> = {
  center: styles.verticalCenter,
};

export const Badge: React.FC<BadgeProps> = ({ count, size, color, alignment }) => {
  const labelSize = size || "medium";

  return (
    <div className={cn("badge", styles.root, color && colorToClass[color], alignment && alignmentToClass[alignment])}>
      <div className={styles.half} />
      <div className={styles.half}>
        <Label className="notifications-label" size={labelSize} circular>
          {count}
        </Label>
      </div>
    </div>
  );
};
